import { LegalLayout, CONTACT, H2 } from "./LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" updated="June 2026" testid="privacy-page">
      <p>
        {CONTACT.name} ("Pinpoint Media Intelligence", "we", "us", or "our") respects your privacy. This Privacy
        Policy explains what information we collect, how we use it, and the choices you have when you use our
        website and SMS messaging services.
      </p>

      <H2>Information We Collect</H2>
      <p>
        We collect information you provide directly to us, including your name, email address, ZIP code, and — if
        you choose to receive text messages — your mobile phone number and your SMS consent. We also collect
        limited technical information (such as device and usage data) automatically when you visit our website.
      </p>

      <H2>How We Use Your Information</H2>
      <ul className="list-disc pl-6 space-y-1">
        <li>To deliver the local deals and offers you request.</li>
        <li>To send SMS communications you have explicitly opted in to receive.</li>
        <li>To operate, maintain, and improve our website and services.</li>
        <li>To comply with legal and regulatory obligations.</li>
      </ul>

      <H2>SMS / Text Messaging</H2>
      <p>
        By providing your mobile number and checking the SMS consent box, you agree to receive SMS communications
        from Pinpoint Media Intelligence. Message frequency varies. Message &amp; data rates may apply. You can reply
        STOP at any time to opt out, or HELP for assistance.
      </p>

      <H2>Mobile Information — Non-Sharing Clause</H2>
      <p className="font-[600] text-navy-900" data-testid="privacy-nonsharing-clause">
        No mobile information will be shared with third parties/affiliates for marketing/promotional purposes. All
        the above categories exclude text messaging originator opt-in data and consent; this information will not be
        shared with any third parties.
      </p>

      <H2>Data Retention</H2>
      <p>
        We retain your information for as long as necessary to provide our services and to comply with our legal
        obligations. You may request deletion of your information at any time by contacting us.
      </p>

      <H2>Your Choices</H2>
      <p>
        You may opt out of SMS messages at any time by replying STOP. You may request access to or deletion of your
        personal information by contacting us at the details below.
      </p>

      <H2>Contact Us</H2>
      <p>
        {CONTACT.name}<br />
        {CONTACT.address}<br />
        Email: <a href={`mailto:${CONTACT.email}`} className="underline text-navy-900">{CONTACT.email}</a>
      </p>
    </LegalLayout>
  );
}
